import get from 'lodash/get';
import * as innovationByDesign from '../../action_creators/ibd/innovation_by_design_action_creators';
import InnovationByDesignModel from '../../../models/ibd/innovation_by_design_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchInnovationByDesignDetail(params, store) {
  return function firstDispatch(dispatch) {
    return InnovationByDesignModel.fetch(params, store)
      .then(function handleInnovationByDesignDetailData(
        InnovationByDesignData
      ) {
        if (params.category) {
          const hasIBDCategory = InnovationByDesignData.data.rows.filter(
            category => category.url === params.category
          );

          if (!get(hasIBDCategory, 'length')) {
            dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          }
        }

        dispatch(
          innovationByDesign.innovationByDesignLoaded(
            InnovationByDesignData.data,
            store,
            params.year
          )
        );
      })
      .catch(function handleUserError(err) {
        if (err.message === 'Invalid Year') {
          log.warn('User tried a most creative people page with invalid year.');
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          return dispatch(
            innovationByDesign.innovationByDesignLoadError(err, store)
          );
        }

        const status = get(err, 'response.status');

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in innovationByDesign actions, message: ${err.message}`
          );
        }
        return dispatch(
          innovationByDesign.innovationByDesignLoadError(err, store)
        );
      });
  };
}
